import {
  GetWeekDayListActionTypes,
  GET_WEEKDAY_LIST_FAIL,
  GET_WEEKDAY_LIST_LOADING,
  GET_WEEKDAY_LIST_SUCCESS,
  GetWeekDayListState,
  GET_WEEKDAY_LIST_UPDATE_API_MSG,
  GET_WEEKDAY_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetWeekDayListRes } from "./Model";

const initialStateGetPosts: GetWeekDayListState = {
  loading: false,
  getWeekDayListRes: {} as GetWeekDayListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getWeekDayListReducer = (
  state = initialStateGetPosts,
  action: GetWeekDayListActionTypes
): GetWeekDayListState => {
  switch (action.type) {
    case GET_WEEKDAY_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_WEEKDAY_LIST_SUCCESS:
      return {
        ...state,
        getWeekDayListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_WEEKDAY_LIST_FAIL:
      return {
        ...state,
        getWeekDayListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_WEEKDAY_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getWeekDayListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_WEEKDAY_LIST_UPDATE_API_RES:
      return {
        ...state,
        getWeekDayListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
